import { callExternalApi } from "./external-api.service";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

export const getCompanyForSiret =
    (accessToken, siret) => getProtectedResource(`company/${siret}/infos`, accessToken);

export const saveCompanyInfos =
    (accessToken, siret, data) => postProtectedResource(`company/${siret}/infos`, accessToken, data);

export const getUserForEmail =
    (accessToken, email) => getProtectedResource(`user/${email}`, accessToken);

export const saveCseElection =
    (accessToken, electionId, data) => postProtectedResource(`cse/${electionId}`, accessToken, data);

export const saveListRepresentation =
  (accessToken, data) => postProtectedResource(`cse/listRepresentation`, accessToken, data);

export const getCompanies = (accessToken) => getProtectedResource(`companies`, accessToken);


const getProtectedResource = async (path, accessToken) => {
  const config = {
    url: `${apiServerUrl}/${path}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};
const postProtectedResource = async (path, accessToken, body) => {
  const config = {
    url: `${apiServerUrl}/${path}`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: body,
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data || null,
    error,
  };
};
